import { Link } from "react-router";
import { Compass } from "lucide-react";
import { PublicShell } from "@/components/gettingIn/PublicShell";
import { Column, StatusHead } from "@/components/gettingIn/parts";
import { kitButtonClass } from "@/app/routes/dashboard/components/kit/Button";
import { cn } from "@/utils/helpers";

/** Unknown routes use the same public frame as sign-in: ground, wordmark, a
 *  status, and one pill. No grid, no square card. */
export default function NotFoundPage() {
  return (
    <PublicShell title="Page not found">
      <Column>
        <p className="font-mono text-[11px] font-medium tracking-[0.18em] text-co-faint">404</p>
        <StatusHead icon={Compass} title="Off the map">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </StatusHead>
        <Link
          to="/"
          className={cn(
            kitButtonClass({ variant: "primary", size: "lg" }),
            "unstyled-link h-12 w-full gap-2.5 px-[22px] text-[15px] font-semibold",
            "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-co-accent",
          )}
        >
          Back to home
        </Link>
      </Column>
    </PublicShell>
  );
}
